import {ContentBlocks_Headline as HeadlineType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/content_blocks.types';
import {
  ContentBlockHeadline,
  RowSection,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled as linariaStyled} from '@linaria/react';
import React from 'react';
import sc from 'styled-components';
import {alignmentMap, fontMap, transformImage} from '../transforms';

export const Headline: React.FC<{
  content: HeadlineType;
  blockId?: number;
  testId?: string;
}> = ({content, blockId, testId = 'customPageHeadline'}) => {
  if (!content.logo && content.text.text === '') return null;

  return (
    <StyledRowSection
      $backgroundColor={content.backgroundColor}
      constrained={false}
      data-content-block={blockId}
    >
      <StyledContentBlockHeadline
        text={{
          alignment: alignmentMap[content.text.alignment],
          color: content.text.color,
          size: fontMap[content.text.size],
          text: content.text.text,
          testId,
        }}
        logo={content.logo && transformImage(content.logo)}
        testId={testId}
      />
    </StyledRowSection>
  );
};

const StyledRowSection = linariaStyled(RowSection)<{$backgroundColor?: string}>`
  background-color: ${({$backgroundColor}) => $backgroundColor ?? ''};
  padding-bottom: 1.5rem;
  padding-top: 3rem;

  ${tabletAndUpLinaria('padding-top: 4rem;')};
`;

const StyledContentBlockHeadline = sc(ContentBlockHeadline)`
  padding: 0 1rem;
`;
